import {
  UseMutationResult,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";

import { getApiClient } from "@punchup/utils/apiRegistry";

export type ThemeColorField =
  | "accent_color"
  | "logo_background_color"
  | "header_background_color"
  | "header_border_color"
  | "top_section_background_color"
  | "top_section_gradient_color";

interface UpdateVenuePageThemeParams {
  venuePageId: string;
  venuePageSlug: string;
  field: ThemeColorField;
  value: string | null;
}

async function updateVenuePageTheme(
  params: UpdateVenuePageThemeParams
): Promise<unknown> {
  return getApiClient().patch(
    `/api/v2/manager/venues/${params.venuePageId}/theme`,
    {
      venuePageSlug: params.venuePageSlug,
      field: params.field,
      value: params.value,
    }
  );
}

export function useUpdateVenuePageTheme(
  venuePageSlug: string
): UseMutationResult<unknown, Error, UpdateVenuePageThemeParams> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateVenuePageTheme,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["venue-page-theme", venuePageSlug],
      });
    },
  });
}
